import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetIndividualsStatisticsResponse } from "./type";

async function getIndividualsStatistics(): Promise<GetIndividualsStatisticsResponse> {
  const url = apiPaths.individuals.statistics;
  const response = await apiClient.get<GetIndividualsStatisticsResponse>(url);

  return response.data;
}

export function useGetIndividualsStatistics(options?: SWRConfiguration) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    "fetch-get-individuals-statistics",
    getIndividualsStatistics,
    mergedOptions,
  );
}
